import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { merge } from "lodash";

export const STRIPE_AUTH_PATHNAME = "/stripe-auth";

interface Entity {
  accountId?: string;
}

interface InitialState {
  entity: Entity | null;
  isLoading: boolean;
  error: any;
}

export const initialState: InitialState = {
  entity: null,
  error: null,
  isLoading: false,
};

const stripeAuthSlice = createSlice({
  name: "stripe",
  initialState,
  reducers: {
    setAccountId: (state, action: PayloadAction<string>) => {
      state.entity = merge(state.entity, { accountId: action.payload });
    },
    clearAccountId: (state) => {
      state.entity = null;
    },
  },
});

export const { setAccountId, clearAccountId } = stripeAuthSlice.actions;

export default stripeAuthSlice;
